import { useQuery } from '@tanstack/react-query';
import Fetch from '../../../../../../core/util/core/Fetch';
import config from '../../../../../config/config';

// GeoJSON usa [lng, lat]; o Leaflet espera [lat, lng].
export function toLeafletPositions(geometry) {
    const ring = coordinates => coordinates.map(([lng, lat]) => [lat, lng]);
    const polygon = rings => rings.map(ring);

    if (geometry.type === 'Polygon') return polygon(geometry.coordinates);
    if (geometry.type === 'MultiPolygon') return geometry.coordinates.map(polygon);
    return null;
}

/**
 * Setores censitários da cidade com desenho, hierarquia (Grupo > Setor > Bairro) e métricas do Censo do ano.
 * Sem ano (''), o backend usa o mais recente importado; ano null (anos ainda carregando) aguarda.
 * Métricas ausentes ou sob sigilo do IBGE chegam como null.
 */
const useCensusTracts = (cityId, year) =>
    useQuery({
        queryKey: ['census-tracts', cityId, year],
        queryFn: async () => {
            const rows = await Fetch.post(config.endpoints.backend + 'governanceroom/sectors/census', {
                city_id: cityId,
                year: year || null
            });

            // Fetch.post não rejeita em erro HTTP: devolve o corpo { message }.
            if (!Array.isArray(rows)) {
                throw new Error(rows?.message || 'Erro ao buscar dados do Censo.');
            }

            return rows
                .map(({ geometry, ...tract }) => ({ ...tract, polygon: toLeafletPositions(geometry) }))
                .filter(tract => tract.polygon);
        },
        enabled: Boolean(cityId) && year !== null && year !== undefined
    });

export default useCensusTracts;
